import React, { Fragment, useEffect, useState } from 'react';
import TableCommon from '../../../../components/common/table/TableCommon';
import { useParams } from 'react-router-dom';
import * as CommonService from '../../../../services/CommonService';
import { SUPPLIER } from '../../../../services/endpoint';
import { Button, Col, DatePicker, message, Row } from 'antd';
import { currencyVND, dateToString } from '../../../../utils';
import { TICKET_TYPE } from '../../../../utils/const';
import moment from 'moment';

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

const DEFAULT_DATE = {
	from: moment(new Date()).subtract(30, 'd'),
	to: moment(new Date())
};

export default (props) => {

	const { id } = useParams();
	const [ds, setDs] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [searchValues, setSearchValues] = useState({
		from: DEFAULT_DATE.from.format('YYYY-MM-DD'),
		to: DEFAULT_DATE.to.format('YYYY-MM-DD')
	});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});


	useEffect(() => {
		if (props.reload) {
			onSearch();
		}
	}, [props.reload]);


	useEffect(() => {
		onSearch();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		try {
			const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
			setLoading(true);
			const resp = await CommonService.get(`${SUPPLIER}/debt-history/${id}`, param);
			setDs(resp.data?.contents);
			setPage({
				total: resp.data?.totalElements,
				...pageParam
			});
		} catch (err) {
			message.error(err?.data?.message);
		} finally {
			setLoading(false);
		}

	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã phiếu',
			dataIndex: 'debtCode',
			align: 'center',
			width: 150
		},
		{
			title: 'Loại phiếu',
			dataIndex: 'ticketType',
			width: 200,
			align: 'center',
			render: (value) => TICKET_TYPE[value]
		},
		{
			title: 'Ngày tạo',
			dataIndex: 'createdDate',
			width: 200,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Ngày ghi nhận',
			dataIndex: 'updatedDate',
			width: 200,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Giá trị thay đổi',
			dataIndex: 'amountChange',
			width: 250,
			align: 'center',
			render: (value) => currencyVND(value)
		},
		{
			title: 'Công nợ',
			dataIndex: 'currentDebt',
			width: 250,
			align: 'center',
			render: (value) => <b style={{ color: 'blue' }}>{currencyVND(value)}</b>
		}
	];

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	return (
		<Fragment>
			<Row gutter={12}>
				<Col className={'mb-20'} span={9} style={{ display: 'flex', alignItems: 'center' }}>
					<DatePicker.RangePicker
						allowClear
						format={'YYYY-MM-DD'}
						placeholder={['Từ ngày', 'Đến ngày']}
						style={{ width: '400px' }}
						defaultValue={[DEFAULT_DATE.from, DEFAULT_DATE.to]}
						onChange={(value) => {
							const arr = value.map(el => el.format('YYYY-MM-DD'));
							handleChange(arr[0], 'from');
							handleChange(arr[1], 'to');
						}} />
					<Button type="primary"
									style={{ width: '150px', marginLeft: '10px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</Col>
			</Row>
			<TableCommon
				loading={loading}
				bordered={true}
				page={page}
				setPage={setPage}
				datasource={ds}
				columns={columns}
				onSearch={onSearch}
			/>
		</Fragment>);
};

